export default {
    version:'v1.0',// 版本号
    apiTimeout: 15000,
    lang: 'zh',// zh 中文 en 英文
    appId:'8000418004',// 应用id
}
